import { render, staticRenderFns } from "./ExpandTemplate.vue?vue&type=template&id=331c08ca&scoped=true"
import script from "./ExpandTemplate.vue?vue&type=script&lang=js"
export * from "./ExpandTemplate.vue?vue&type=script&lang=js"
import style0 from "./ExpandTemplate.vue?vue&type=style&index=0&id=331c08ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331c08ca",
  null
  
)

export default component.exports